import { Card, Chip, Container, Grid, Paper, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import ButtonAction from 'src/components/Button.js/SaveButton';
import ComboBox from 'src/components/Input/ComboBox';
import TextInput from 'src/components/Input/TextInput';
import Iconify from 'src/components/iconify';
import Loader from 'src/components/loader/loader';
import ChangePassModal from 'src/components/modal/ChangePassModal';
import { sendRequest, serviceList, session } from 'src/utils';
import crypt from 'src/utils/service/crypt';

const ConfigEmailSMTP = () => {
    const { t } = useTranslation();
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const optionMethodSMTP = [
        {
            value: 'tls',
            label: 'TLS',
        },
        {
            value: 'ssl',
            label: 'SSL',
        },
        {
            value: 'none',
            label: 'None',
        },
    ];
    const optionLanguages = [
        {
            value: 'vi',
            label: 'Việt Nam',
        },
        {
            value: 'en',
            label: 'English',
        },
        {
            value: 'jp',
            label: 'Japanese',
        },
    ];
    const [value, setValue] = useState({
        server_smtp: '',
        email_smtp: '',
        password: '',
        port_smtp: '',
        method_smtp: {},
        connection_smtp: 1000,
        languages: optionLanguages.filter((row) => row.value === localStorage.getItem(session.LOCAL_LANGUAGE))[0],
        id: 0
    })
    const [isSubmit, setIsSubmit] = useState(false);
    const addFlag = useRef(false);
    const [flagAddStat, setFlagAddStat] = useState(false);

    const [dataSMTP, setDataSMTP] = useState(null);
    const getRefSMTP = useRef(false);
    const [getFlagsSMTP, setGetFlagsSMTP] = useState(false);

    const [visibleChangePassword, setVisibleChangePassword] = useState(false);

    const [dataUsers, setDataUsers] = useState([]);
    const getRefUser = useRef(false);
    const [getFlagsUser, setGetFlagsUser] = useState(false);
    const searchValueDeboun = useRef('');
    // const throttled = useRef(debounce(() => getDataUsers(), 1000));

    const [getValueUser, setGetValueUser] = useState('');
    const [getValueEmailCC, setGetValueEmailCC] = useState('');
    const [userSend, setUserSend] = useState([]);
    const [emailCCSend, setEmailCCSend] = useState([]);

    const addFlagSendEmail = useRef(false);
    const [flagAddSendEmail, setFlagAddSendEmail] = useState(false);

    const addFlagEmailReceive = useRef(false);
    const [flagAddEmailReceive, setFlagAddEmailReceive] = useState(false);

    const addFlagRemoveEmailReceive = useRef(false);
    const [flagRemoveEmailReceive, setFlagRemoveEmailReceive] = useState(false);

    const [dataMailReceive, setDataMailReceive] = useState([]);
    const [dataMailReceiveCC, setDataMailReceiveCC] = useState([]);
    const getRefMailReceive = useRef(false);
    const [getFlagsMailReceive, setGetFlagsMailReceive] = useState(false);

    const menu = sessionStorage.getItem('menu');
    let screenPermissions = {};

    if (menu) {
        try {
            const data = JSON.parse(crypt.deCode(menu));
            // console.log('Loading menu', data[0]);
            screenPermissions = data[0].filter((item) => item.screens_key === 'ch_email')[0];
            // console.log('screenPermissions', screenPermissions);
        } catch (error) {}
    }

    useEffect(() => {
        setTimeout(() => {
            getDataSMTP();
            getDataEmailReceive();
            // getDataUsers();
        }, 1000);
    }, []);

    const handleOnChangeText = (e, key = 'name') => {
        setValue({ ...value, [key]: e });
    };

    const handleEdit = () => {
        setIsSubmit(true);
        if (addFlag.current === true) return;
        if (
            !value.server_smtp ||
            !value.email_smtp ||
            !value.password ||
            !value.port_smtp ||
            !value.method_smtp ||
            !value.languages ||
            !value.connection_smtp
        )
            return toast.error(t('error.param'));

        addFlag.current = true;
        setFlagAddStat(true);

        let InVal = [
            value.email_smtp,
            value.server_smtp,
            value.password,
            +value.connection_smtp,
            value.method_smtp.value,
            value.port_smtp,
            value.languages.value,
            value.id
        ];
        sendRequest(serviceList.processSMTP, InVal, actionResult, true, timeOutFunct, 40000);
    };
    const actionResult = (reqInfoMap, message) => {
        addFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            setValue({});
            setIsSubmit(false);
            getDataSMTP();
        }
    };
    const timeOutFunct = (reqInfo) => {
        addFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    const getDataSMTP = useCallback(() => {
        if (getRefSMTP.current) {
            return;
        }
        getRefSMTP.current = true;
        setGetFlagsSMTP(true);
        const InVal = [];
        sendRequest(serviceList.getByIdSMTP, InVal, getDataResultSMTP, true, timeOutFunctSMTP, 40000);
    }, []);

    const getDataResultSMTP = (reqInfoMap, message) => {
        getRefSMTP.current = false;
        setGetFlagsSMTP(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            // toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0].o_1;
            if (data) {
                setDataSMTP(data);
                setValue({
                    ...value,
                    server_smtp: data.server,
                    email_smtp: data.email,
                    password: data.password,
                    port_smtp: data.port,
                    method_smtp: { value: data.email_smtp_method, label: data.email_smtp_method.toUpperCase() },
                    connection_smtp: data.time_connect,
                    languages: optionLanguages.filter((row) => row.value === data.languages)[0],
                    id: data.id
                });
            }
        }
    };

    const timeOutFunctSMTP = (reqInfo) => {
        getRefSMTP.current = false;
        setGetFlagsSMTP(false);
        toast.error(t('error.time_out'));
    };

    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isValidEmailCC, setIsValidEmailCC] = useState(true);

    const handleEmailChange = (event) => {
        const enteredEmail = event.target.value;
        setGetValueUser(enteredEmail.replace(/\s+/g, ''));

        // Kiểm tra định dạng email bằng biểu thức chính quy
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        setIsValidEmail(emailPattern.test(enteredEmail));
    };

    const handleEmailCCChange = (event) => {
        const enteredEmail = event.target.value;
        setGetValueEmailCC(enteredEmail.replace(/\s+/g, ''));

        // Kiểm tra định dạng email bằng biểu thức chính quy
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        setIsValidEmailCC(emailPattern.test(enteredEmail));
    };

    const handleGetUserSend = (type = 'receive') => {
        if (type === 'receive') {
            if (!isValidEmail) {
                toast.error('Error: ' + t('email_valid'));
            }
            if (getValueUser) {
                let arrNew = [...userSend];
                if (!arrNew.some((item) => item === getValueUser)) {
                    // toast.success(t('action_success_'))
                    arrNew.push(getValueUser);
                    handleInsertEmailReceive(getValueUser);
                    setUserSend(arrNew);
                    setGetValueUser('');
                } else {
                    toast.error('Error: ' + t('err_message_list_email'));
                    setUserSend(arrNew);
                    setGetValueUser('');
                }
            }
        } else {
            if (!isValidEmailCC) {
                toast.error('Error: ' + t('email_valid'));
            }
            if (getValueEmailCC) {
                let arrNew = [...userSend];
                if (!arrNew.some((item) => item === getValueEmailCC)) {
                    // toast.success(t('action_success_'))
                    arrNew.push(getValueEmailCC);
                    handleInsertEmailReceive(getValueEmailCC, '1');
                    setGetValueEmailCC('');
                } else {
                    toast.error('Error: ' + t('err_message_list_email'));
                    setGetValueEmailCC('');
                }
                setEmailCCSend(arrNew);
            }
        }
    };

    const handleKeyDown = (event, type = 'receive') => {
        // Check if the pressed key is "Enter" (key code 13)

        if (event.key === 'Enter' || event.keyCode === 13 || event.which === 13) {
            // Call the onEnterPress function if it's provided
            handleGetUserSend(type);
        }
    };

    const getDataEmailReceive = useCallback(() => {
        if (getRefMailReceive.current) {
            return;
        }
        getRefMailReceive.current = true;
        setGetFlagsMailReceive(true);
        sendRequest(
            serviceList.getListEmailReceive,
            [999999999, '0'],
            getDataResultEmailReceive,
            true,
            timeOutFunctEmailReceive,
            40000
        );
        sendRequest(
            serviceList.getListEmailReceive,
            [999999999, '1'],
            getDataResultEmailReceiveCC,
            true,
            timeOutFunctEmailReceive,
            40000
        );
    }, []);

    const getDataResultEmailReceive = (reqInfoMap, message) => {
        getRefMailReceive.current = false;
        setGetFlagsMailReceive(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            // toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            let data = message.proc_data.rows[0].o_1;
            setDataMailReceive(data);
        }
    };

    const getDataResultEmailReceiveCC = (reqInfoMap, message) => {
        getRefMailReceive.current = false;
        setGetFlagsMailReceive(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            // toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            let data = message.proc_data.rows[0].o_1;
            setDataMailReceiveCC(data);
        }
    };

    const timeOutFunctEmailReceive = (reqInfo) => {
        getRefMailReceive.current = false;
        setGetFlagsMailReceive(false);
        toast.error(t('error.time_out'));
    };

    const handleInsertEmailReceive = (email, type = '0') => {
        if (addFlagEmailReceive.current === true) return;

        addFlagEmailReceive.current = true;
        setFlagAddEmailReceive(true);

        // const newArrUserSend = userSend.map((item) => item.value);

        let InVal = [email, screenPermissions.id, type];
        sendRequest(
            serviceList.insertEmailReceive,
            InVal,
            actionResultInsertEmailReceive,
            true,
            timeOutFunctInsertEmailReceive,
            40000
        );
    };
    const actionResultInsertEmailReceive = (reqInfoMap, message) => {
        addFlagEmailReceive.current = false;
        setFlagAddEmailReceive(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            setTimeout(() => {
                getDataEmailReceive();
            }, 500);
        }
    };
    const timeOutFunctInsertEmailReceive = (reqInfo) => {
        addFlagEmailReceive.current = false;
        setFlagAddEmailReceive(false);
        toast.error(t('error.time_out'));
    };

    const handleDeleteEmailReceive = (email) => {
        if (addFlagRemoveEmailReceive.current === true) return;

        addFlagRemoveEmailReceive.current = true;
        setFlagRemoveEmailReceive(true);

        let InVal = [email.id, screenPermissions.id];
        sendRequest(
            serviceList.deleteEmailReceive,
            InVal,
            actionResultDeleteEmailReceive,
            true,
            timeOutFunctDeleteEmailReceive,
            40000
        );
    };
    const actionResultDeleteEmailReceive = (reqInfoMap, message) => {
        addFlagRemoveEmailReceive.current = false;
        setFlagRemoveEmailReceive(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            setTimeout(() => {
                getDataEmailReceive();
            }, 500);
        }
    };
    const timeOutFunctDeleteEmailReceive = (reqInfo) => {
        addFlagRemoveEmailReceive.current = false;
        setFlagRemoveEmailReceive(false);
        toast.error(t('error.time_out'));
    };

    // console.log('getUser', dataUsers);

    const handleSendEmail = () => {
        if (addFlagSendEmail.current === true) return;

        addFlagSendEmail.current = true;
        setFlagAddSendEmail(true);

        // const newArrUserSend = userSend.map((item) => item.value);
        const newArrUserSend = dataMailReceive?.map((item) => ({
            email_receive: item.email_receive,
            email_cc: emailCCSend,
        }));
        let InVal = newArrUserSend;
        sendRequest(serviceList.sendEmailSMTP, InVal, actionResultSendEmail, true, timeOutFunctSendEmail, 400000);
    };
    const actionResultSendEmail = (reqInfoMap, message) => {
        addFlagSendEmail.current = false;
        setFlagAddSendEmail(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            // console.log(message.proc_data);
        }
    };
    const timeOutFunctSendEmail = (reqInfo) => {
        addFlagSendEmail.current = false;
        setFlagAddSendEmail(false);
        toast.error(t('error.time_out'));
    };

    return (
        <>
            <Helmet>
                <title> {t('config_email')} </title>
            </Helmet>
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1} flexWrap={'wrap'}>
                    <Typography variant="h4" gutterBottom>
                        {t('config_email')}
                    </Typography>{' '}
                </Stack>{' '}
                <Breadcrumb paths={[{ label: t('config_email'), url: '#', navigate: false }]} flexWrap={'wrap'} />
                <Loader loading={getFlagsSMTP} />
                <ChangePassModal
                    fuctGet={getDataResultSMTP}
                    emailSMTP={dataSMTP?.id}
                    visible={visibleChangePassword}
                    setVisible={setVisibleChangePassword}
                    isConfigEmailSMTP
                />
                <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                    <Card
                        maxWidth={isSmallScreen ? '100%' : '50%'}
                        sx={{ width: isSmallScreen ? '100%' : '35%', height: '440px' }}
                    >
                        <Grid container spacing={2} padding={5}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                                <Typography variant="h6" gutterBottom>
                                    {t('Email SMTP')}
                                </Typography>{' '}
                            </Stack>{' '}
                            <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                <TextInput
                                    label={t('server_smtp')}
                                    valueChange={value.server_smtp}
                                    getValue={(e) => handleOnChangeText(e, 'server_smtp')}
                                    required
                                    autoFocus
                                    error={!value.server_smtp && isSubmit}
                                    helperText={!value.server_smtp && isSubmit ? t('required_input') : ''}
                                />
                            </Grid>
                            <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                <TextInput
                                    label={t('email_smtp')}
                                    valueChange={value.email_smtp}
                                    getValue={(e) => handleOnChangeText(e, 'email_smtp')}
                                    required
                                    error={!value.email_smtp && isSubmit}
                                    helperText={!value.email_smtp && isSubmit ? t('required_input') : ''}
                                />
                            </Grid>
                            {(dataSMTP?.length === 0 || dataSMTP === null) && (
                                <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                    <TextInput
                                        label={t('password')}
                                        type="password"
                                        valueChange={value.password}
                                        getValue={(e) => handleOnChangeText(e, 'password')}
                                        required
                                        error={!value.password && isSubmit}
                                        helperText={!value.password && isSubmit ? t('required_input') : ''}
                                    />
                                </Grid>
                            )}
                            <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                                <TextInput
                                    label={t('port_smtp')}
                                    valueChange={value.port_smtp}
                                    getValue={(e) => handleOnChangeText(e, 'port_smtp')}
                                    required
                                    error={!value.port_smtp && isSubmit}
                                    helperText={!value.port_smtp && isSubmit ? t('required_input') : ''}
                                />
                            </Grid>
                            <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                                <ComboBox
                                    label={t('method_smtp')}
                                    valueSelect={value.method_smtp?.value || null}
                                    valueEqual="value"
                                    getValue={(e) => handleOnChangeText(e, 'method_smtp')}
                                    selectOption={optionMethodSMTP}
                                    required
                                    error={!value.method_smtp && isSubmit}
                                    helperText={!value.method_smtp && isSubmit ? t('required_input') : ''}
                                />
                            </Grid>
                            <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                <ComboBox
                                    label={t('languages')}
                                    valueSelect={value.languages?.value || null}
                                    valueEqual="value"
                                    getValue={(e) => handleOnChangeText(e, 'languages')}
                                    selectOption={optionLanguages}
                                    required
                                    error={!value.languages && isSubmit}
                                    helperText={!value.languages && isSubmit ? t('required_input') : ''}
                                />
                            </Grid>
                            <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    flexWrap={'wrap'}
                                    spacing={2}
                                >
                                    {screenPermissions?.update_permission === '1' && dataSMTP && (
                                        <Stack direction="column">
                                            <ButtonAction
                                                onClick={handleEdit}
                                                type={dataSMTP && 'update'}
                                                title={dataSMTP && t('update')}
                                            />
                                        </Stack>
                                    )}
                                    {screenPermissions?.insert_permission === '1' && (
                                        <Stack direction="column" display={dataSMTP && 'none'}>
                                            <ButtonAction onClick={handleEdit} type={'save'} title={t('save')} />
                                        </Stack>
                                    )}
                                    {screenPermissions?.update_permission === '1' && dataSMTP && (
                                        <Stack direction="column">
                                            <ButtonAction
                                                onClick={() => setVisibleChangePassword(true)}
                                                type={'change'}
                                                title={t('change_password')}
                                            />
                                        </Stack>
                                    )}
                                </Stack>
                            </Grid>
                        </Grid>
                    </Card>
                    <Card
                        maxWidth={isSmallScreen ? '100%' : '50%'}
                        sx={{ width: isSmallScreen ? '100%' : '62%', height: '440px' }}
                    >
                        <Grid container spacing={2} padding={5}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                                <Typography variant="h6" gutterBottom>
                                    {t('list_receive_email')}
                                </Typography>
                            </Stack>
                            <Grid container spacing={2} item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                <Grid item xl={10} md={10} sm={12} style={{ width: '100%' }}>
                                    <TextField
                                        label={t('email_receive_input')}
                                        size="small"
                                        fullWidth
                                        value={getValueUser}
                                        onChange={handleEmailChange}
                                        onKeyDown={handleKeyDown}
                                        autoFocus={dataSMTP ? true : false}
                                    />
                                </Grid>
                                <Grid item xl={2} md={2} sm={12} style={{ width: '100%', margin: 'auto' }}>
                                    <ButtonAction
                                        disabled={!getValueUser}
                                        onClick={() => handleGetUserSend()}
                                        type={'save'}
                                        title={t('save')}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item sm={12} style={{ width: '100%' }}>
                                <Paper
                                    spacing={1}
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        overflow: 'auto',
                                        maxHeight: 300,
                                    }}
                                >
                                    {dataMailReceive.length > 0 &&
                                        dataMailReceive.map((item, idx) => (
                                            <Chip
                                                sx={{ width: 'fit-content', marginLeft: 0.5, marginTop: 0.5 }}
                                                key={idx}
                                                variant="outlined"
                                                color="primary"
                                                label={item.email_receive}
                                                onDelete={() => handleDeleteEmailReceive(item)}
                                            />
                                        ))}
                                </Paper>
                            </Grid>
                            {/* EMAIL CC */}
                            <Grid container spacing={2} item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                <Grid item xl={10} md={10} sm={12} style={{ width: '100%' }}>
                                    <TextField
                                        label={t('email_receive_cc')}
                                        size="small"
                                        fullWidth
                                        value={getValueEmailCC}
                                        onChange={handleEmailCCChange}
                                        onKeyDown={(e) => handleKeyDown(e, 'CC')}
                                    />
                                </Grid>
                                <Grid item xl={2} md={2} sm={12} style={{ width: '100%', margin: 'auto' }}>
                                    <ButtonAction
                                        onClick={() => handleGetUserSend('CC')}
                                        type={'save'}
                                        title={t('save')}
                                        disabled={!getValueEmailCC}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item sm={12} style={{ width: '100%' }}>
                                <Paper
                                    spacing={1}
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        overflow: 'auto',
                                        maxHeight: 300,
                                    }}
                                >
                                    {dataMailReceiveCC.length > 0 &&
                                        dataMailReceiveCC.map((item, idx) => (
                                            <Chip
                                                sx={{ width: 'fit-content', marginLeft: 0.5, marginTop: 0.5 }}
                                                key={idx}
                                                variant="outlined"
                                                color="primary"
                                                label={item.email_receive}
                                                onDelete={() => handleDeleteEmailReceive(item)}
                                            />
                                        ))}
                                </Paper>
                            </Grid>
                            <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                <ButtonAction
                                    onClick={() => handleSendEmail()}
                                    type={'other'}
                                    title={t('send_email_warning')}
                                    startIcon={<Iconify icon="uil:fast-mail" />}
                                    color={'warning'}
                                    variant={'contained'}
                                />
                            </Grid>
                        </Grid>
                    </Card>
                </Stack>
                <Loader loading={addFlagSendEmail.current} />
            </Container>
        </>
    );
};

export default ConfigEmailSMTP;
